import React, { useState, useEffect, useRef } from "react";
import { ContentContainer } from "@layout";
import {
	Button,
	DownloadButton,
	LoadingComponent,
	NoDataFoundTemplate,
	Select,
} from "../../../components/core";
import Papa from "papaparse";
import { ClearingReportGQL } from "../../../constants/graphql/operatrions";
import { useLazyQuery } from "@apollo/client";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

function formatDate(inputDate) {
	if (inputDate == null) {
		return "";
	}
	const date = new Date(inputDate);
	const options = { year: "numeric", month: "short", day: "numeric" };
	return date.toLocaleDateString(undefined, options);
}

export default function ClearingReport() {
	const [csvData, setCsvData] = useState([]);
	const [loadOnce, setloadOnce] = useState(false);
	const [resultHeader, setresultHeader] = useState("");
	const dt = useRef(null);

	const formatDate1 = (e) => {
		return formatDate(e.oldestPackageDate);
	};

	const [loading, setLoading] = React.useState(false);
	const [fetchChartData, resultFetchChartData] = useLazyQuery(
		ClearingReportGQL,
		{ fetchPolicy: "no-cache" }
	);

	const handleSearch = () => {
		setloadOnce(true);
		fetchChartData({})
			.then((r) => {
				setCsvData(r.data.lockersWithOverduePackages);
				setLoading(false);
			})
			.catch((e) => {
				console.log(e);
				setLoading(false);
			});
	};

	return (
		<ContentContainer containerTitle={"Locker Clearing Summary"}>
			<Button
				value={"SEARCH"}
				onClick={(event) => {
					setLoading(true);
					handleSearch();
				}}
				className={"w-40 h-8 m-5"}
			/>
			<div>
				<div>
					{csvData.length === 0 && !loading && loadOnce && (
						<div>
							<NoDataFoundTemplate width={56} height={56} />
						</div>
					)}
				</div>
				{!loading > 0 && loadOnce && csvData.length != 0 && (
					<>
						<div className="flex flex-row gap-1">
							<p>Total: </p>
							<p className="font-bold">{csvData.length}</p>
						</div>
						<DownloadButton
							dt={dt}
							id={"Locker with Overdue Package Summary"}
							csvOnly={true}
						/>
						<div
							className="bg-primary-primaryYellow p-2 border-b-2 border-stone-400"
							id="Locker with Overdue Package Summary"
						>
							<p className="font-bold text-center">
								Locker with Overdue Package Summary
							</p>
							<DataTable
								paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
								currentPageReportTemplate="Rows per page"
								paginator
								paginatorRight
								rowsPerPageOptions={[10, 20, 50]}
								rows={10}
								value={csvData}
								sortMode="multiple"
								multiSortMeta={[{ field: "totalPackages", order: -1 }]}
								tableStyle={{ minWidth: "50%" }}
								exportFilename="Suspicious Courier Report"
								stripedRows
								showGridlines
								className="border-2 border-stone-400"
								ref={dt}
							>
								<Column
									header={"Locker"}
									field="lockerName"
									sortable
									style={{ minWidth: "10%" }}
									headerStyle={{ backgroundColor: "#facc15", color: "black" }}
								/>
								<Column
									header={">30 days Overdue Packages"}
									field="totalPackages"
									sortable
									style={{ minWidth: "10%" }}
									headerStyle={{ backgroundColor: "#facc15", color: "black" }}
								/>
								<Column
									header={"Oldest Package"}
									field="oldestPackageDate"
									sortable
									body={formatDate1}
									style={{ minWidth: "10%" }}
									headerStyle={{ backgroundColor: "#facc15", color: "black" }}
								/>
							</DataTable>
						</div>
					</>
				)}
				{loading && <LoadingComponent />}
			</div>
		</ContentContainer>
	);
}
